export default "__VITE_ASSET__BRX1QeYZ__"